export const educationData = [
  {
    id: 1,
    institution: "Guvi Geek Networks, IITM Research Park",
    course: "MERN-Full Stack Development",
    startYear: "Mar 2024",
    endYear: "Jun 2024",
  },
  {
    id: 2,
    institution: "Anna University - Loyola Institute of Technology",
    course: "B.E-Electronics and Communication Engineering",
    startYear: "2018",
    endYear: "2022",
  },
  {
    id: 3,
    institution: "Sethu Bhaskara Matriculation Higher Secondary School",
    course: "1st Group-Computer science",
    startYear: "2016",
    endYear: "2018",
  },
];
